import axios from "axios";
import Vue from "vue";
import Component from "vue-class-component";
import { headers } from "@/libs/backend/restAPI/headers";
import IGeneratedLeadReport from "@/interfaces/IGeneratedLeadReport";
import ICountry from "@/interfaces/countries/ICountry";

import GeneratedLeadReportForm from "../GeneratedLeadReportForm/GeneratedLeadReportForm.vue";
import GeneratedLeadReportCountries from "../GeneratedLeadReportCountries/GeneratedLeadReportCountries.vue";

@Component({
  components: {
    GeneratedLeadReportForm,
    GeneratedLeadReportCountries,
  },
})
export default class GeneratedLeadReportList extends Vue {
  private countries: {
    loading: boolean;
    list: Readonly<ICountry[]>;
  } = {
    loading: false,
    list: [],
  };

  private leadReports: {
    loading: boolean;
    list: Readonly<IGeneratedLeadReport[]>;
    page: number;
    hasMore: boolean;
  } = {
    loading: false,
    list: [],
    page: 1,
    hasMore: true,
  };

  private showedCreateReportModal = false;

  private get tableFields() {
    return [
      {
        key: "id",
        label: "ID",
        sortable: false,
      },
      {
        key: "createdAt",
        label: "Дата создания",
        sortable: false,
      },
      {
        key: "dateFrom",
        label: "Период с",
        sortable: false,
      },
      {
        key: "dateTo",
        label: "Период по",
        sortable: false,
      },
      {
        key: "amount",
        label: "Сумма",
        sortable: false,
      },
      {
        key: "countries",
        label: "Страны",
        sortable: false,
      },
      {
        key: "rewardType",
        label: "Тип",
        sortable: false,
      },
      {
        key: "downloadLink",
        label: "Отчёт (с датой и временем)",
        sortable: false,
      },
      {
        key: "downloadLink2",
        label: "Отчёт (только с датой)",
        sortable: false,
      },
    ];
  }

  private formatDate(val: string, showTime = false) {
    return new Date(val).toLocaleString("ru", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: showTime ? "2-digit" : undefined,
      minute: showTime ? "2-digit" : undefined,
    });
  }

  private formatCountries(val: string[]) {
    return this.countries.list.reduce<string[]>((acc, { code, name }) => {
      if (val.includes(code)) {
        acc.push(name);
      }

      return acc;
    }, []);
  }

  private getFilename(val: string) {
    return val.split("/").reverse()[0];
  }

  private onGenerateReport({
    showedInfoMessage,
  }: {
    showedInfoMessage: boolean;
  }) {
    this.showedCreateReportModal = showedInfoMessage;
    this.leadReports.hasMore = true;
    this.leadReports.page = 1;
    this.fetchLeadReports();
  }

  private showCreateModal() {
    this.showedCreateReportModal = true;
  }

  private async fetchCountries() {
    if (this.countries.loading) {
      return;
    }

    try {
      const { data } = await axios
        .create({
          headers: headers(),
          baseURL: process.env.VUE_APP_API_HOST,
        })
        .get("/api/vpn/countries", {
          params: {
            pagination: true,
            limit: 400,
            page: 1,
          },
        });

      this.countries.list = Object.freeze(data);
      this.countries.loading = false;
    } catch (error) {
      this.countries.list = [];
      this.countries.loading = false;
    }
  }

  private async fetchLeadReports() {
    if (this.leadReports.loading) {
      return;
    }

    this.leadReports.loading = true;

    const perPage = 30;

    try {
      const { data } = await axios
        .create({
          headers: headers(),
          baseURL: process.env.VUE_APP_API_HOST,
        })
        .get("/api/main/generated_lead_report_views", {
          params: {
            per_page: perPage,
            page: this.leadReports.page,
          },
        });

      this.leadReports.loading = false;
      this.leadReports.list =
        this.leadReports.page === 1
          ? Object.freeze(data)
          : Object.freeze(this.leadReports.list.concat(data));

      this.leadReports.page++;
      this.leadReports.hasMore = data.length === perPage;
    } catch (error) {
      this.leadReports.loading = false;
    }
  }

  private mounted() {
    this.fetchLeadReports();
    this.fetchCountries();
  }
}
